import React from 'react'
import { Box } from '@mui/material'
import { formatPrice } from '@ui-seeker/utils'
import {tableColorsErrorRange, tableColorsMediumRange, tableColorsSuccessRange} from "../../@signals";


export default function priceColumn( firstThirdIndex, secondThirdIndex) {
	return {
		name: 'price', label: 'Price',
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { id_master_currency_translation }, idx) =>
				<RealTimeTableDataPriceContent
					value={value}
					position={idx}
					currency={id_master_currency_translation}
					firstThirdIndex={firstThirdIndex}
					secondThirdIndex={secondThirdIndex}
				/>
		}
	}
}

const RealTimeTableDataPriceContent = props => {
	const {
		value,
		position,
		currency,
		firstThirdIndex,
		secondThirdIndex,
	} = props

	// The heat colour stays (it ranks the price); it sits in a pill instead of filling the whole cell.
	return <Box sx={{ textAlign: 'center', py: 1, px: 1 }}>
		<Box component="span" sx={{
			display: 'inline-block', px: 1.25, py: 0.5, borderRadius: '6px', fontWeight: 600, fontSize: 13,
			...(position <= firstThirdIndex
				? tableColorsSuccessRange.value.getColor(Math.floor(value))
				: position >= firstThirdIndex && position <= secondThirdIndex
					? tableColorsMediumRange.value.getColor(value)
					: tableColorsErrorRange.value.getColor(value)
			),
		}}>
			{formatPrice(value, currency)}
		</Box>
	</Box>
}